import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    risks: [
        {
            id: '1',
            title: 'Sample Risk',
            position: { x: 100, y: 100 },
            onScreen: true,
            items: [
                {
                    id: '1-1',
                    title: 'Risk Item 1',
                    impact: 3,
                    probability: 4,
                }
            ]
        }
    ]
};

export const riskRegisterSlice = createSlice({
    name: 'riskRegister',
    initialState,
    reducers: {
        addRisk: (state, action) => {
            state.risks.push({
                id: Date.now().toString(),
                title: action.payload.title || 'New Risk',
                position: action.payload.position || { x: 100, y: 100 },
                onScreen: true,
                items: []
            });
        },
        updateRisk: (state, action) => {
            const { id, updates } = action.payload;
            const risk = state.risks.find(r => r.id === id);
            if (risk) {
                Object.assign(risk, updates);
            }
        },
        updateRiskPosition: (state, action) => {
            const { id, position } = action.payload;
            const risk = state.risks.find(r => r.id === id);
            if (risk) {
                risk.position = position;
            }
        },
        deleteRisk: (state, action) => {
            state.risks = state.risks.filter(r => r.id !== action.payload);
        },
        addRiskItem: (state, action) => {
            const { riskId, item } = action.payload;
            const risk = state.risks.find(r => r.id === riskId);
            if (risk) {
                risk.items = risk.items || [];
                risk.items.push({
                    id: Date.now().toString(),
                    title: item.title || 'New Risk Item',
                    impact: item.impact || 1,
                    probability: item.probability || 1,
                });
            }
        },
        updateRiskItem: (state, action) => {
            const { riskId, itemId, updates } = action.payload;
            const risk = state.risks.find(r => r.id === riskId);
            if (risk && risk.items) {
                const item = risk.items.find(i => i.id === itemId);
                if (item) {
                    Object.assign(item, updates);
                }
            }
        },
        deleteRiskItem: (state, action) => {
            const { riskId, itemId } = action.payload;
            const risk = state.risks.find(r => r.id === riskId);
            if (risk && risk.items) {
                risk.items = risk.items.filter(i => i.id !== itemId);
            }
        },
        setRisks: (state, action) => {
            state.risks = action.payload;
        }
    }
});

export const {
    addRisk,
    updateRisk,
    updateRiskPosition,
    deleteRisk,
    addRiskItem,
    updateRiskItem,
    deleteRiskItem,
    setRisks
} = riskRegisterSlice.actions;

export const selectRisks = (state) => state.riskRegister.risks;
export const selectVisibleRisks = (state) => state.riskRegister.risks.filter(r => r.onScreen);

export default riskRegisterSlice.reducer;
